import React, { FunctionComponent, useState, useContext } from 'react';
import { PostContext, PostContextProps } from '/src/contexts/PostContext';
import { Box, IconButton, Tooltip } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { PremiumAdBanner } from '/src/ui/shared/banners/PremiumAdBanner';
import HelpIcon from '@mui/icons-material/Help';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

interface CopyRssLinkButtonProps {
  isPremiumUser: boolean;
}

export const CopyRssLinkButton: FunctionComponent<CopyRssLinkButtonProps> = ({
  isPremiumUser,
}) => {
  const { t } = useTranslation();
  const [audioKey, setAudioKey] = useState<string | null>(null);
  const [keyLoading, setKeyLoading] = useState(false);
  const [tooltipTitle, setTooltipTitle] = useState('');
  const [openPremiumBanner, setOpenPremiumBanner] = useState(false);
  const { getAudioKey } = useContext(PostContext) as PostContextProps;

  const handleCopyButtonClick = async () => {
    if (!isPremiumUser) {
      return setOpenPremiumBanner(true);
    }
    setKeyLoading(true)

    const newAudioKey = audioKey || (await getAudioKey());

    if (newAudioKey) {
      const audioLink = `${window.location.origin}/audio.rss?k=${newAudioKey}`
      copy(audioLink);
      setAudioKey(newAudioKey);
      setTooltipTitle('copiedLabel');
    } else {
      setTooltipTitle('serverError');
    }

    setKeyLoading(false)
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Tooltip
        title={tooltipTitle ? String(t(tooltipTitle)) : ''}
        arrow
        enterTouchDelay={0}
      >
        <LoadingButton onClick={handleCopyButtonClick} loading={keyLoading}>
          {t('rssLink')}
        </LoadingButton>
      </Tooltip>
      <IconButton aria-label="help" href="/post/1087/">
        <HelpIcon />
      </IconButton>
      <PremiumAdBanner
        open={openPremiumBanner}
        onClose={() => setOpenPremiumBanner(false)}
      />
    </Box>
  );
};
